/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_PausedInputs */



/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Timer_PausedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_paused = /** @type {((inputs?: Timer_PausedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_PausedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En pause")
	if (locale === "es") return /** @type {LocalizedString} */ ("En pausa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Em pausa")
	if (locale === "it") return /** @type {LocalizedString} */ ("In pausa")
	return /** @type {LocalizedString} */ ("Paused")
});